import React, { useEffect, useState } from "react";
import { getAdminPayments } from "@/api";
import { fmtMxn } from "./adminShared";

export default function AdminPayments() {
  const [payments, setPayments] = useState([]);
  useEffect(() => {
    getAdminPayments().then(setPayments).catch(() => {});
  }, []);

  const total = payments.reduce((acc, p) => acc + (p.amount || 0), 0);

  return (
    <div data-testid="admin-payments">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow mb-2">Finanzas</p>
          <h1 className="font-serif-hc font-light text-3xl md:text-4xl text-[#F5F2EA]">Pagos</h1>
        </div>
        <div className="text-right">
          <p className="text-[10px] tracking-[0.2em] uppercase text-[#A3A095]">Total cobrado</p>
          <p data-testid="payments-total" className="font-serif-hc text-3xl text-[#C4A661]">{fmtMxn(total)}</p>
        </div>
      </div>

      <div className="mt-7 overflow-x-auto border border-[#1E2B25]">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="bg-[#0C1310] text-left">
              {["Fecha", "Cliente", "Tour", "Monto", "Método", "Nota"].map((h) => (
                <th key={h} className="p-4 eyebrow font-normal">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p.id} data-testid={`payment-row-${p.id}`} className="border-t border-[#1E2B25]">
                <td className="p-4 text-[#A3A095] whitespace-nowrap">{(p.at || "").slice(0, 10)}</td>
                <td className="p-4 text-[#F5F2EA]">{p.client}</td>
                <td className="p-4 text-[#F5F2EA]">{p.tour_name}</td>
                <td className="p-4 text-[#C4A661] whitespace-nowrap">{fmtMxn(p.amount)}</td>
                <td className="p-4 text-[#A3A095] capitalize">{p.method}</td>
                <td className="p-4 text-[#A3A095]">{p.note || "—"}</td>
              </tr>
            ))}
            {!payments.length && (
              <tr><td colSpan={6} className="p-10 text-center text-[#A3A095]" data-testid="payments-empty">Aún no hay pagos registrados. Regístralos desde el detalle de cada reserva.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
